import { mascararCep, mascararDocumento, somenteDigitos } from "../hooks/usePaisFiscal";

// Pagamento, troco, endereço e CPF/CNPJ da venda — do lado da tela. As chaves
// são as que o backend aceita (`backend/src/helpers/DadosDeEntrega.ts`); aqui
// só os rótulos.

export const FORMAS_DE_PAGAMENTO = [
	["dinheiro", "Dinheiro"],
	["pix", "Pix"],
	["cartao_credito", "Cartão de crédito"],
	["cartao_debito", "Cartão de débito"],
	["boleto", "Boleto"],
	["link", "Link de pagamento"],
];

export const CAMPOS_DO_ENDERECO = [
	"cep",
	"endereco",
	"numero",
	"complemento",
	"bairro",
	"cidade",
	"uf",
	"referencia",
];

// O backend só aceita documento brasileiro (11 ou 14 dígitos).
const BR = { pais: "BR", tamanhosDocumento: [11, 14], tamanhoCep: 8 };

export const mascaraDoDocumento = (valor) => mascararDocumento(valor, BR);
export const mascaraDoCep = (valor) => mascararCep(valor, BR);
export const documentoValido = (valor) =>
	[0, 11, 14].includes(somenteDigitos(valor).length);

// "Rua X, 12 — Centro, Cidade/UF" para ler de relance.
export const enderecoEmTexto = (e) => {
	if (!e) return "";
	const rua = [e.endereco, e.numero, e.complemento].filter(Boolean).join(", ");
	const local = [e.cidade, e.uf].filter(Boolean).join("/");
	return [rua, e.bairro, local].filter(Boolean).join(" — ");
};

// Os dois endereços dizem o mesmo? Vazio e ausente contam igual, e o CEP
// com ou sem traço também (o servidor grava só os dígitos).
const normalizado = (e, c) => {
	const v = String(e?.[c] || "").trim();
	return c === "cep" ? somenteDigitos(v) : c === "uf" ? v.toUpperCase() : v;
};
export const mesmoEndereco = (a, b) =>
	CAMPOS_DO_ENDERECO.every((c) => normalizado(a, c) === normalizado(b, c));

// Rua, bairro, cidade e UF pelo CEP. Falhou (rede, CEP inexistente): null, e
// a pessoa segue digitando à mão.
export const buscarCep = async (cep) => {
	const digitos = somenteDigitos(cep);
	if (digitos.length !== 8) return null;

	try {
		const resposta = await fetch(`https://viacep.com.br/ws/${digitos}/json/`);
		const dados = await resposta.json();
		if (dados.erro) return null;
		return {
			endereco: dados.logradouro || "",
			bairro: dados.bairro || "",
			cidade: dados.localidade || "",
			uf: dados.uf || "",
		};
	} catch {
		return null;
	}
};
